import { FC } from 'react';
import styles from './Breadcrumbs.module.scss';
import Link from 'next/link';

interface IBreadcrumbs {
  firstPageName: string;
  secondPageName?: string;
  thirdPageName?: string;
  fourthPageName?: string;
  firstPageAlias?: string;
  secondPageAlias?: string;
  thirdPageAlias?: string;
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ firstPageName, secondPageName, thirdPageName, fourthPageName, firstPageAlias, secondPageAlias, thirdPageAlias }) => {
  return (
    <ul className={styles.b_breadcrumbs}>
      <li className={styles.item}>
        <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href="/">
          Главная
        </Link>
      </li>
      <li className={styles.item}>
        {!!firstPageAlias ? (
          <Link prefetch={false} href={`${firstPageAlias}`}>
            {firstPageName}
          </Link>
        ) : (
          <>{firstPageName}</>
        )}
      </li>
      {!!secondPageName && (
        <li className={styles.item}>
          {!!secondPageAlias ? (
            <Link prefetch={false} href={`${secondPageAlias}`}>
              {secondPageName}
            </Link>
          ) : (
            <>{secondPageName}</>
          )}
        </li>
      )}
      {!!thirdPageName && (
        <li className={styles.item}>
          {!!thirdPageAlias ? (
            <Link prefetch={false} href={`${thirdPageAlias}`}>
              {thirdPageName}
            </Link>
          ) : (
            <>{thirdPageName}</>
          )}
        </li>
      )}
      {!!fourthPageName && <li className={styles.item}>{fourthPageName}</li>}
    </ul>
  );
};

export default Breadcrumbs;
